import { render } from "./EnterScore.vue?vue&type=template&id=2eaa981d&scoped=true"
import script from "./EnterScore.vue?vue&type=script&lang=js"
export * from "./EnterScore.vue?vue&type=script&lang=js"

import "./EnterScore.vue?vue&type=style&index=0&id=2eaa981d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eaa981d"]])

export default __exports__